<template>
  <!-- 污染源一张图 -->
  <div style="color: #fff; font-size: 40px;position: relative">
    <!--<earth style="position: fixed;top:0;left:0;z-index:100"></earth>-->
    <!-- 弹出框区域 start -->
    <!-- 站点信息 -->
    <div class="window-container" v-if="window && window.visible">
      <div class="window-close" @click="close">x</div>
      <div class="site-infos">
        <div class="site-infos-content">
          <div style="display: flex;overflow: hidden;">
            <img v-if="siteDetail.onlineStatus" src="../../../../../assets/others/index/wifi2.gif"
              :title="[siteDetail.onlineStatus ? '站点在线' : '站点离线']"
              style="width: 30px; height: 30px; margin-right: 10px" />
            <img v-if="!siteDetail.onlineStatus" src="../../../../../assets/others/index/wifi5.gif"
              :title="[siteDetail.onlineStatus ? '站点在线' : '站点离线']"
              style="width: 34px; height: 30px; margin-right: 10px;" />
            <div class="site-name"
              style="cursor: pointer;font-size: 20px;max-width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
              :title="siteDetail.name">
              {{ siteDetail.name }}
            </div>
          </div>
          <div style="font-size: 12px;color: #0ff;line-height: 40px;">{{ siteDetail.lastTime }}</div>
        </div>
        <div style="width: 570px; height: 100%;margin-top: 10px;">
          <file-table type="5" height="375px" top='0' :dateList="dateLists" @toggleState="toggledetailState" minSum='9'
            v-if="fileState"></file-table>
        </div>
        <div
          style="color: #fff; font-size: 18px; text-align: right; cursor: pointer; user-select: none;margin-top: 10px;"
          @click="ontoSite()">
          查看更多>>>
        </div>
      </div>
    </div>
    <!-- 视频监控 -->
    <div class="window-container" v-else-if="(!(window && window.visible) && (monitorWindow.visible))">
      <div class="window-close" @click="close">x</div>
      <div class="window-title" @click="close">{{ monitorWindow.name }}</div>
      <div class="window-content">
        <videoItem margin="0" height="auto" :widthRatio="1" :heightRatio="0.7" ref="video" :siteId="monitorWindow.id">
        </videoItem>

      </div>
    </div>
    <!-- 站点列表 -->
    <div class="window-container"
      v-else-if="(!(window && window.visible) && !(monitorWindow.visible) && (markerWindow.visible))">
      <div class="window-close" @click="close">x</div>
      <div class="window-title" style="height: 30px;">
        <a-radio-group style="top: 10px;" v-model="radioValue" @change="changeRadio">
          <a-radio :value="1">全部</a-radio>
          <a-radio :value="2">在线</a-radio>
          <a-radio :value="3">离线</a-radio>
        </a-radio-group>
      </div>

      <!-- <div class="window-title" @click="close">{{ selectedMarkerObj.name }}({{ selectedMarkerObj.value }}个)</div> -->
      <div class="window-content" style="height: 62vh;position: relative;">
        <warn v-if="warnState" :siteWarnList="selectedMarkerObj.showMarkerList" siteType="7" top='0' marginTop="0"
          height="58vh" @changetadios='changetadios' @toggleState="togglewarnState" minSum='14'
          @onToClickItem="onToClickItem"></warn>
        <!-- <div style="height: 100%;" v-if="selectedMarkerObj.showMarkerList.length > 0">
          <div @click="onToClickItem(item)" v-for="item in selectedMarkerObj.showMarkerList" class="marker-item">


            <div class="marker-item-content" :class="item.onlineStatus">
              <div class="marker-item-name">
                <img v-if="item.onlineStatus"
                  class="marker-item-icon"
                  src="../../../../../assets/others/index/wifi2.gif" :title="[item.onlineStatus ? '站点在线' : '站点离线']"
                  />
                <img class="marker-item-icon" v-if="!item.onlineStatus" src="../../../../../assets/others/index/wifi5.gif"
                  :title="[item.onlineStatus ? '站点在线' : '站点离线']"
                  />{{ item.name }}
              </div>
              <div class="marker-item-lasttime">最后通讯时间：{{ item.lastTime }}</div>
            </div>

          </div>
        </div>
        <div v-else class="no-data">暂无数据</div> -->
      </div>
    </div>
    <!-- 弹出框区域 end -->

    <el-amap class="amap-box" ref="maps" :amapManager="amapManager" :zoom='zoom' :dragEnable="true" :center="center"
      :mapStyle="mapStyle" :plugin="plugin" pitch='55' viewMode='3D' v-if="mapControlindex == 0">
      <el-amap-marker v-for="marker in markerList" :position="marker.position" :content="marker.content"
        :key="marker.id" :events="marker.events" :label="marker.label" v-if="marker.show"></el-amap-marker>
      <div v-for="pipe in pipeList" :key="pipe.id">
        <el-amap-polyline strokeColor="#55aaff" v-for="(line, index) in pipe.lines" :key="index"
          :path="line"></el-amap-polyline>
        <!--<el-amap-marker v-for="(line,index) in pipe.lines" :key="index" :position="line[0]" :content="`<span style='padding: 5px 10px;background-color: #fff;color: #2eabff;border-radius: 5px;word-break: keep-all;white-space: nowrap'>${pipe.title}</span>`" :offset="pipeOffset" ></el-amap-marker>-->
      </div>
      <el-amap-marker v-for="marker in wellList" :position="marker.position" :content="marker.content" :key="marker.id"
        :events="marker.events"></el-amap-marker>
      <!-- 监视着视频列表 -->
      <el-amap-marker v-for="marker in monitorVideoList" :position="marker.position" :content="marker.content"
        :key="marker.id" :events="marker.events" :label="marker.label" v-if="marker.show"></el-amap-marker>
      <!-- <el-amap-info-window v-if="window" :position="window.position" :visible="window.visible" :offset="window.offset"> -->
      <!-- 站点详情第一版 start -->
      <!-- <div class="site-container">
					<div class="site-header">
						<div class="site-header-container">
							<img :src="siteDetail.photo" />
							<div class="site-header-content">
								<div class="site-header-name">
									<img v-if="siteDetail.onlineStatus" src="../../../../../assets/others/index/wifi2.gif" :title="[siteDetail.onlineStatus ? '站点在线' : '站点离线']"
									 style="width: 30px; height: 30px; margin-right: 10px" />
									<img v-if="!siteDetail.onlineStatus" src="../../../../../assets/others/index/wifi5.gif" :title="[siteDetail.onlineStatus ? '站点在线' : '站点离线']"
									 style="width: 44px; height: 40px; margin-right: 10px" />
									<div class="site-name" style="cursor: pointer" :title="[siteDetail.onlineStatus ? '站点在线' : '站点离线']">
										{{ siteDetail.name }}
									</div>
								</div>
								<div class="site-header-name">
									<div class="iconfont icon-area"></div>
									<div class="site-area">{{ siteDetail.areaFullName }}</div>
								</div>
								<div class="site-header-name">
									<div class="iconfont icon-heliu"></div>
									<div class="site-area">{{ siteDetail.riverFullName }}</div>
								</div>
							</div>
						</div>
						<div></div>
						<div style="width: 570px; height: 100%;border: 1px solid #fff;border-radius: 10px;margin-top: 15px;">
							<file-table type="5" height="362px" top='0' :dateList="dateLists" paddingTop='20px'></file-table>
							<div v-if="standText != ''" :class="[standState ? 'realtime-bg' : 'realtime-bg-red']">
								<span>{{ standText }}</span>{{ standLabel }}
							</div>
						</div>
					</div>
					<div style="display: flex">
						<div class="site-items">
							<img src="@assets/others/index/warn.png" style="width: 60px" />
							<div class="site-details">
								<span style="font-size: 35px; color: #0ff; margin-top: 15px; font-family: 'UnidreamLED'">{{
                  siteDetail.warnSum
                }}</span>
								<span style="font-size: 15px">预警数量</span>
							</div>
						</div>
						<div class="site-items">
							<img src="@assets/others/index/monitor.png" style="width: 60px" />
							<div class="site-details">
								<span style="font-size: 35x; color: #0ff; margin-top: 15px; font-family: 'UnidreamLED'">{{
                  siteDetail.onlineSum
                }}</span>
								<span style="font-size: 15px">检测数量</span>
							</div>
						</div>
						<div class="site-items">
							<img src="@assets/others/index/upload.png" style="width: 60px" />
							<div class="site-details">
								<span style="font-size: 20px; color: #0ff; margin-top: 15px; font-family: 'UnidreamLED'">{{
                  siteDetail.onlineRatio
                }}</span>
								<span style="font-size: 15px">数据上传率</span>
							</div>
						</div>
						<div class="site-items">
							<img src="@assets/others/index/time.png" style="width: 60px" />
							<div class="site-details" style="line-height: 20px; justify-content: center">
								<span style="font-size: 20px; color: #0ff; margin-top: 15px; font-family: 'UnidreamLED'; text-align: center">{{ siteDetail.lastTime }}</span>
								<span style="font-size: 15px; text-align: center">最后检测时间</span>
							</div>
						</div>
					</div>
					<div style="width: 100%; height: 370px; overflow: hidden; margin-top: -100px">
						<dial v-if="window.visible" ref="dials" marginLeft="15%" position="" height="480px" width="580px" left="300px"
						 top="0px"></dial>
					</div>
					<div style="color: #fff; font-size: 18px; text-align: right; cursor: pointer; user-select: none" @click="ontoSite()">
						查看更多>>>
					</div>
				</div> -->
      <!-- end -->

      <!-- <div class="site-infos">
					<div class="site-infos-content">
						<div style="display: flex;flex:4;overflow: hidden;">
							<img v-if="siteDetail.onlineStatus" src="../../../../../assets/others/index/wifi2.gif" :title="[siteDetail.onlineStatus ? '站点在线' : '站点离线']"
							 style="width: 30px; height: 30px; margin-right: 10px" />
							<img v-if="!siteDetail.onlineStatus" src="../../../../../assets/others/index/wifi5.gif" :title="[siteDetail.onlineStatus ? '站点在线' : '站点离线']"
							 style="width: 34px; height: 30px; margin-right: 10px;" />
							<div class="site-name" style="cursor: pointer;font-size: 20px;max-width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
							 :title="siteDetail.name">
								{{ siteDetail.name }}
							</div>
						</div>
						<div style="font-size: 12px;color: #0ff;line-height: 40px;flex:1;">{{siteDetail.lastTime}}</div>
					</div>
					<div style="width: 570px; height: 100%;margin-top: 10px;">
						<file-table type="5" height="375px" top='0' :dateList="dateLists" @toggleState="toggledetailState" minSum='9' v-if="fileState"></file-table>
					</div>
					<div style="color: #fff; font-size: 18px; text-align: right; cursor: pointer; user-select: none;margin-top: 10px;"
					 @click="ontoSite()">
						查看更多>>>
					</div>
				</div> -->
      <!-- </el-amap-info-window> -->
    </el-amap>
    <!-- <div class="map-tag">
			<div style="display: flex">
				<div :class="standShape" v-for="(item, index) in tagList" :title="item.name" :style="'background-color:' + [item.show ? item.color : '#ccc']"
				 :key="index" @click="selctTag(index)">
					{{ item.name }}
				</div>
			</div>
		</div> -->
    <div class="bg-content">
      <div style="width: 25%">
        <border ref="ratioBorder" siteName="设备在线" iconfont="icon-hangyefenbu" top="30">
          <ratio @chartClick="chartClick" v-if="showState && ratioWidth && ratioHeight" :width='ratioWidth'
            :height="ratioHeight" :tableName="inlineRadio" top="12px" ref="ratio"></ratio>
        </border>
        <border ref="companyBorder" siteName="企业信息" iconfont="icon-hangyefenbu" top="30">
          <warn v-if="reportState" :siteWarnList="companyList" siteType="6" height="50vh"
            @toggleState="toggleCompanyReport" minSum='13' @onToClickItem="onToClickItem"></warn>
        </border>
        <!-- <border ref="ballBorder" siteName="达标率" iconfont="icon-biaozhunhuadabiao">
					<ball v-if="showState && ballWidth && ballHeight" :width='ballWidth' :height="ballHeight" top="0"
						left="0" ref="ball"></ball>
				</border>
				<border ref="columnBorder" siteName="主要污染物" iconfont="icon-wuranyuanguanli">
					<a-radio-group v-if="!mapControlindex" :defaultValue="defaultValue" @change="changeRadio">
						<a-radio :value="1">24H</a-radio>
						<a-radio :value="2">7天</a-radio>
						<a-radio :value="3">30天</a-radio>
					</a-radio-group>
					<pillar v-if="showState && columnWidth && columnHeight" :width='columnWidth' :height="columnHeight"
						ref="column" top="36px" left="-8px"></pillar>
				</border> -->
      </div>
      <div style="width: 28%;margin-right: 15px">
        <border ref="warnBorder" siteName="流量日报" iconfont="icon-icon-test1" top="30">
          <a-select v-model="factorValue" class="factor-select" style="position:absolute;top: 10px;right: 10px;width: 150px;text-align: center;" size="small">
            <a-select-option v-for="item in dateFactorList" :key="item.code" :value="item.code">{{ item.title }}</a-select-option>
          </a-select>
          <!-- <dailyReport></dailyReport> -->
          <warn v-if="reportState" :factorObjValue="factorObjValue" :siteWarnList="dateList" siteType="5" height="50vh" @toggleState="toggleReport"
            minSum='13'></warn>
          <!-- <warn v-else-if="selectType == 31" :siteWarnList="dateList" siteType="4" height="590px"></warn> -->
        </border>
        <border ref="warnBorder1" siteName="站点警报" iconfont="icon-yujing1">
          <warn v-if="warnState" :radioStatu='radioStatu' :current='defaultValues' :defaultValue='defaultValues'
            :siteWarnList="waterWarnList" siteType="1" top='70px' height="25vh" @changetadios='changetadios'
            @toggleState="togglewarnState" minSum='5'>
            <template #radio>
              <!-- <div> -->
              <!-- <a-select size="small" :default-value="defaultDayValue" style="width: 120px" @change="changeDayRadio">
                <a-select-option :value="1">
                  24H
                </a-select-option>
                <a-select-option :value="2">
                  7天
                </a-select-option>
                <a-select-option :value="3">
                  30天
                </a-select-option>
              </a-select> -->
              <a-radio-group :defaultValue="defaultDayValue" @change="changeDayRadio">
                <a-radio :value="1">24H</a-radio>
                <a-radio :value="2">7天</a-radio>
                <a-radio :value="3">30天</a-radio>
              </a-radio-group>
              <!-- </div> -->
            </template>
          </warn>
        </border>
      </div>
    </div>
    <map-tag :tabList="tabList" :selectIndex="selectIndex" @OntoTab="OntoTab" @onselectMap="onselectMap"
      @onselectNet="onselectNet" @onselectRoad="onselectRoad" :mapSelectindex="mapSelectindex"
      :netSelectindex="netSelectindex" :roadSelectindex="roadSelectindex" :labelState="labelState"
      @onToChangeLabel="onToChangeLabel"></map-tag>
    <map-legend type="1" :onlineStateList="onlineStateList" @selctTag="selctTag" :standardList="standardList"
      :standShape="standShape"></map-legend>
  </div>
</template>
<script>
import dailyReport from '../com/dailyReport.vue'
import imgUrl from '@/assets/others/index/bg.gif'
import {
  queryWastSiteStand,
  queryWastDateList,
  queryPipeSystem,
  queryManholeCover
} from '@/api/api'
import Vue from 'vue'
import VueAMap from 'vue-amap' //注意不要和 AMap原始名称覆盖
let amapManager = new VueAMap.AMapManager()
// 预警组件
import warn from '../com/warn'
import border from '@/components/border/borderType'
// 达标率
import ball from '@/components/env-bigData/ball'
// 主要污染物
import pillar from '@/components/env-bigData/pillar'
//水质分布
import ratio from '@/components/env-bigData/ratio'
// 空气质量指数表盘图
import instrument from '@/components/env-bigData/instrument'
// 空气质量指数进度图
import barType from '@/components/env-bigData/barType'
import fileTable from '@/components/border/fileTable'
// 空气质量天数表盘图
import plate from '@/components/env-bigData/plate'
// 空气质量天数双表盘图
import doublePlate from '@/components/env-bigData/doublePlate'
import mapTag from '../com/mapTag'
import mapLegend from '../com/mapLegend.vue'
import videoItem from '../com/video'
import {
  commonRender
} from '@/mixins/commonRender'
import {
  queryRealtime,
  mainRealtime,
  querySiteList,
  queryStandardTreeList,
  queryWasteStand,
  queryWastRankSkylist,
  queryWastegasStand,
  queryWastesoilStand,
  queryAreaInfo
} from '@/api/api'
import {
  getAction,
} from '@/api/manage'
import dial from '@/components/env-bigData/watch'
import Earth from '@/components/Map/earth'
export default {
  mixins: [commonRender],
  components: {
    dailyReport,
    videoItem,
    mapLegend,
    Earth,
    border,
    dial,
    ratio,
    warn,
    ball,
    pillar,
    fileTable,
    instrument,
    barType,
    plate,
    doublePlate,
    mapTag
  },
  data() {
    return {
      district: null,
      citys: [],
      ratioWidth: '',
      ratioHeight: '',
      ballWidth: '',
      ballHeight: '',
      columnWidth: '',
      columnHeight: '',
      fileState: true,
      warnState: true,
      reportState: true,
      inlineRadio: '',
      tagList: [{
        'name': '',
        show: true,
        color: 'green',
        id: 0
      }, {
        'name': '',
        show: true,
        color: 'red',
        id: 0
      }],
      firstPollution: {},
      standLabel: '',
      standText: '',
      showState: true,
      selectIndex: '',
      standState: false,
      dateLists: [],
      windows: [],
      window: '',
      standardList: [],
      markerList: [],
      waterWarnList: [],
      // 日报数据
      dateList: [],
      // 日报因子选择
      dateFactorList: [],
      factorValue: window.localStorage.getItem('fengtianSelect') || '',
      // 水质分布数据
      standardMap: [],
      // 达标率
      compliant: 1,
      siteDetail: {},
      netSelectindex: 0,
      roadSelectindex: 0,
      mapControlindex: 0,
      time: [],
      labelData: [],
      pollutionData: [],
      amapManager,
      center: [118.047928, 24.613341],
      // mapStyle: 'amap://styles/dark', //设置地图样式
      zoom: 15,
      markers: [{
        position: [120.726149, 29.951588],
      },],
      siteWarnList: [],
      mapSelectindex: 0,
      imgUrl: require('../../../../../assets/others/index/bg.gif'),
      wrongUrl: require('../../../../../assets/others/index/wrong.png'),
      plugin: [{
        pName: 'MapType',
        defaultType: 0,
        showRoad: false,
        showButton: false,

        showTraffic: false,
        events: {
          init(o) { },
        },
      },],
      // tabList: [
      // 	// {
      // 	//   name: '水质监控',
      // 	//   type: 1,
      // 	// },
      // 	// {
      // 	//   name: '空气质量',
      // 	//   type: 2,
      // 	// },
      // 	// {
      // 	//   name: '土壤监控',
      // 	//   type: 3,
      // 	// },
      // 	{
      // 		name: '废水',
      // 		st: '32',
      // 		iconfont: 'icon-shuizhijiance',
      // 	},
      // 	{
      // 		name: '废气',
      // 		st: '31',
      // 		iconfont: 'icon-app_icons--',
      // 	},
      // 	{
      // 		name: '土壤',
      // 		st: '35',
      // 		iconfont: 'icon-turang',
      // 	},
      // ],
      selectType: '32',
      defaultValue: 1,
      pipeList: [],
      wellList: [],
      companyList: [],  //企业信息列表
      monitorVideoList: [],  //监视着视频列表
      monitorImg: require('@/assets/others/monitor.png'),
      monitorWindow: {
        visible: false
      },
      wellImg: require('@/assets/others/well.png'),
      pipeOffset: new AMap.Pixel(-20, -25),
      defaultDayValue: 1,
      warnStartTime: '',
      selectedMarkerObj: {
        showMarkerList: []
      },
      markerWindow: {
        visible: false
      },
      radioValue: 1
    }
  },
  created() {
    // setTimeout(()=>{
    // },500)
    // VueAMap.setZoom(3)
    this.center =
      window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ?
        window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341]
    if (window.localStorage.getItem('areaNameList') && window.localStorage.getItem('areaNameList') != 'null' && window.localStorage.getItem('areaNameList') != 'undefined') {
      this.citys = JSON.parse(window.localStorage.getItem('areaNameList'))
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.onselectMap(1)
      this.onToChangeLabel()
      // this.selectIndex = this.tabList[0].st
      setTimeout(() => {
        this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12
        let map = amapManager.getMap()
        this.setMapTile(map)
      }, 1000)
      this.getMonitorVideoList()
      this.getCompanyList()
    })
    // setInterval(this.scroll, 1000)
    //自适应
    this.resetWidth()
    window.addEventListener('resize', () => {
      this.resetWidth()

    }, false)
    this.getPipeSystem()
    this.getManholeCover()
  },
  watch: {
    radioValue: {
      handler(newVal, oldVal) {
        this.handleRadioData()
      },
      immediate: true,
      deep: true

    },
    factorValue: {
      handler(newVal, oldVal) {
        if(this.factorValue!==''){
          window.localStorage.setItem('fengtianSelect', this.factorValue)
        }
      },
      immediate: true,
      deep: true
    },
  },
  computed: {
    factorObjValue() {
      return this.factorValue !== '' ? this.dateFactorList.find(item => item.code == this.factorValue) : {}
    }
  },
  methods: {
    handleRadioData() {
      if (this.radioValue == 1) {
        this.selectedMarkerObj['showMarkerList'] = JSON.parse(JSON.stringify(this.markerList))
      } else {
        let state = this.radioValue == 2 ? true : false
        this.selectedMarkerObj['showMarkerList'] = JSON.parse(JSON.stringify(this.markerList)).filter(item => {
          return item.onlineStatus == state
        })
      }
    },
    chartClick(item) {
      console.log('chartClick', item)
      this.handleRadioData()
      // let onlineStatus = true
      // if (item.dataIndex == 0) {
      //   onlineStatus = false
      // }
      // item['showMarkerList'] = JSON.parse(JSON.stringify(this.markerList))
      // this.selectedMarkerObj = item
      console.log('selectedMarkerList', this.selectedMarkerObj)
      this.close()
      this.markerWindow.visible = true
    },
    onToClickItem(item) {
      console.log('onToClickItem', item)
      sessionStorage.setItem('selectId', JSON.stringify(item))
      setTimeout(() => {
        this.$emit('siteTurn', true)
      }, 100)
      // this.siteDetail = item
    },
    changeDayRadio(e) {
      console.log('changeDayRadio', e)
      this.warnStartTime = this.getSelectDay(e.target.value)
      this.getWarn(this.radioIndex, this.selectType)
    },
    // 获取监视者视频列表
    getMonitorVideoList() {
      querySiteList({
        st: 61,
        field: 'id,,mn,name,companyName,departName,tenantName,userId_userName,areaName,status_dictText,action',
        current: 1,
        size: 1000000,
        searchCount: true
      }).then(res => {
        if (res.success && res.result) {
          this.monitorVideoList = res.result.records.map(item => {
            return {
              id: item.id,
              position: [item.longitude - 0, item.latitude - 0],
              ...item,
              label: this.labelState ? {
                content: item.name,
                offset: [0, -20]
              } : {
                content: '',
                offset: [0, 0]
              },
              show: true,
              content: this.getVideoShape(
                'green',
                '',
                item.warnStatus,
                item.onlineStatus,
                item.name,
                'icon-icon-jiankong'
              ),
              events: {
                // 点击视频列表
                click: () => {

                  console.log('events', item)
                  this.monitorWindow.visible = true
                  this.monitorWindow.name = item.name
                  this.$nextTick(() => {
                    this.$refs.video.getVideoList(item.id)
                  })
                  this.monitorWindow.id = item.id
                }
              }
            }
          })

          console.log('monitorVideoList', this.companyList)
        }
      })
    },
    // 获取公司列表
    getCompanyList() {
      querySiteList({
        st: 32,
        field: 'id,,mn,name,companyName,departName,tenantName,userId_userName,areaName,status_dictText,action',
        current: 1,
        size: 1000000,
        searchCount: true
      }).then(res => {
        if (res.success && res.result) {
          this.companyList = res.result.records
          console.log('monitorVideoList', this.companyList)
        }
      })
    },
    toggleCompanyReport(value) {
      console.log('toggleCompanyReport', value)
    },
    getVideoShape(bgColor, name, warnState, onlineState, siteName, icon) {
      let warnStyle = ''
      let onlineStyle = ''
      if (warnState && this.markerWarnState) {
        warnStyle = "<img style='width:20px;height:20px;position:absolute;right:-14px;top:-10px;' src='" +
          imgUrl + "' />"
      }
      if (!icon) {
        name = siteName.trim().substr(0, 1)
        console.log('name', name)
        console.log('siteName', siteName)
      }

      if (!onlineState) {
        bgColor = '#ccc'
        // onlineStyle =
        // 	"<div class='iconfont icon-dacha' style='font-size:27px;position:absolute;left:4px;top:0;color:#fff;font-weight:400;'></div>"
      }
      bgColor = '#2c517c'
      return (
        "<div style='position: relative;box-shadow: 0 3px 6px #000;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background-color: " +
        bgColor +
        ";text-align: center;color: #000;line-height: 30px;cursor: pointer;'><div style='width:8px;height:8px;position:absolute;bottom:-3px;left:11px;transform: rotate(45deg);margin-top: -5px;box-shadow: 0 3px 6px #000;background:" +
        bgColor + "'></div><div title='" + siteName +
        "' style='position:absolute;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background-color:" +
        bgColor +
        ";text-align: center;color:#000;line-height: 30px;cursor: pointer;'><div class='iconfont " +
        icon +
        "' style='font-size:15px;color:#fff;text-align: center;line-height: 30px;cursor: pointer;'></div>" +
        name +
        warnStyle +
        onlineStyle +
        "</div></div>"
      )
    },
    // 获取所有管网数据
    getPipeSystem() {
      let that = this
      queryPipeSystem({
        current: 1,
        size: 1000000
      }).then(res => {
        if (res.success && res.result) {
          that.pipeList = res.result.records.map(item => {
            var pointList = item.coordinate.split(':')
            var lines = pointList.map((v) => {
              return v.split('-').map((item) => {
                return item.split(',')
              })
            })
            item.lines = lines
            return item
          })
        }
      })
    },
    // 获取所有窨井盖数据
    getManholeCover() {
      let that = this
      queryManholeCover({
        current: 1,
        size: 1000000
      }).then(res => {
        6
        if (res.success && res.result) {
          that.wellList = res.result.records.map(item => {
            return {
              id: item.id,
              position: item.coordinate.split(','),
              content: `<img style="width: 30px;height: 30px;" src="${this.wellImg}" />`,
              events: () => {
                // 点击窨井盖
              }
            }
          })
        }
      })
    },
    drawBounds() {
      const map = amapManager.getMap();
      let areaRoot = window.localStorage.getItem('areaRoot') && window.localStorage.getItem('areaRoot') != 'null' ? window.localStorage.getItem('areaRoot').split(',') : []
      areaRoot.forEach(item => {
        queryAreaInfo(item).then(res => {
          if (res.success) {
            let features = []
            if (res.result.mapStructure) {
              var pointList = JSON.parse(res.result.mapStructure).features.split(':')
              features = pointList.map((v) => {
                return v.split('-').map((item) => {
                  return item.split(',')
                })
              })
            }
            if (features.length > 0) {
              var outer = [
                new AMap.LngLat(-360, 90, true),
                new AMap.LngLat(-360, -90, true),
                new AMap.LngLat(360, -90, true),
                new AMap.LngLat(360, 90, true)
              ]
              var inline = features.map(area => {
                return area.map(info => {
                  return new AMap.LngLat(info[0], info[1], true)
                })
              })
              var pathArray = [
                outer
              ]
              pathArray.push.apply(pathArray, inline)
              var polygon = new AMap.Polygon({
                // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
                pathL: pathArray,
                //线条颜色，使用16进制颜色代码赋值。默认值为#006600
                strokeColor: 'rgb(20,164,173)',
                strokeWeight: 4,
                //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                strokeOpacity: 0.5,
                //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
                fillColor: 'rgba(99,99,99)',
                //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                fillOpacity: 0.3,
                zIndex: 99999999
              })
              polygon.setPath(pathArray)
              map.add(polygon)
              // features.forEach(area=>{
              //   var polygon = new AMap.Polygon({
              //     // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
              //     path: area,
              //     strokeColor: "#FF33FF",
              //     strokeWeight: 3,
              //     strokeOpacity: 0.5,
              //     fillOpacity: 0.3,
              //     fillColor: "#1791fc",
              //     zIndex: 99999999,
              //   });
              //   map.add(polygon);
              // })

            }
          }
        })
      })
    },
    resetWidth() {
      this.$refs.ratioBorder.width = document.documentElement.clientWidth * 0.25
      this.$refs.ratioBorder.height = document.documentElement.clientHeight * 0.275
      this.$refs.companyBorder.width = document.documentElement.clientWidth * 0.25
      this.$refs.companyBorder.height = document.documentElement.clientHeight * 0.55
      // this.$refs.ballBorder.width = document.documentElement.clientWidth * 0.25
      // this.$refs.ballBorder.height = document.documentElement.clientHeight * 0.275
      // this.$refs.columnBorder.width = document.documentElement.clientWidth * 0.25
      // this.$refs.columnBorder.height = document.documentElement.clientHeight * 0.275
      this.$refs.warnBorder.width = document.documentElement.clientWidth * 0.28
      this.$refs.warnBorder.height = document.documentElement.clientHeight * 0.5
      this.$refs.warnBorder1.width = document.documentElement.clientWidth * 0.28
      this.$refs.warnBorder1.height = document.documentElement.clientHeight * 0.34
      this.ratioWidth = (document.documentElement.clientWidth * 0.24) + 'px'
      this.ratioHeight = (document.documentElement.clientHeight * 0.25) + 'px'
      this.ballWidth = (document.documentElement.clientWidth * 0.25) + 'px'
      this.ballHeight = (document.documentElement.clientHeight * 0.3) + 'px'
      this.columnWidth = (document.documentElement.clientWidth * 0.25) + 'px'
      this.columnHeight = (document.documentElement.clientHeight * 0.24) + 'px'
    },
    close() {
      if (this.window) {
        this.window.visible = false
      }
      this.monitorWindow.visible = false
      this.markerWindow.visible = false
      console.log('close', this.window, this.monitorWindow)
    },
    getApi(st, radioSelected) {
      this.showState = false
      this.$nextTick(() => {
        this.showState = true
        this.defaultValue = 1
        this.warnStartTime = this.getSelectDay(radioSelected)
        setTimeout(() => {
          this.getPollution(this.getDay(1), st)
          this.getData(st)
          this.getDateList(st)
          this.getStandard(st)
          // this.getSite(st)
          this.getWarn(radioSelected, st)
          this.drawBounds()
        }, 100)
      })
    },

    // 获取国标数据
    getStandard(st) {
      // queryStandardTreeList().then((res) => {
      // 	if (res.success) {
      // 		let arr = []
      // 		if (st == '32') {
      // 			res.result.forEach((item, index) => {
      // 				if (item.label == '国家标准') {
      // 					if (item.children != null) {
      // 						item.children.forEach((item1, index1) => {
      // 							if (item1.key == 'K1_3') {
      // 								arr = item1.children
      // 							}
      // 						})
      // 					}
      // 				}
      // 			})
      // 		} else {
      // 			res.result.forEach((item, index) => {
      // 				if (item.label == '国家标准') {
      // 					if (item.children != null) {
      // 						item.children.forEach((item1, index1) => {
      // 							if (item1.key == 'K1_2') {
      // 								arr = item1.children
      // 							}
      // 						})
      // 					}
      // 				}
      // 			})
      // 		}
      //
      // 		arr.forEach((item, index) => {
      // 			item.data.title = item.data.title.replace('类', '')
      // 			item.data.show = true
      // 			return item
      // 		})
      //
      // 	}
      // })
      let arr = [{
        name: '',
        title: '',
        children: [{
          data: {
            show: true,
            color: '#2c517c',
            id: 'monitor',
            icon: 'icon-icon-jiankong',
            title: '监视者监控'
          },
          title: '监视者监控'
        }]
      }, {

      }]
      this.standardList = arr
      this.getSite(st)
    },
    selctTag(index, selectedIndex, id, isOnline) {
      if (isOnline) {
        this.standardList[selectedIndex].children[index].data.show = !this.standardList[selectedIndex].children[index].data.show
        let state = JSON.parse(JSON.stringify(this.standardList[selectedIndex].children[index].data.show))
        console.log(state)
        if (parseInt((this.selectIndex - 0) / 10) == 3) {
          this.markerList.forEach((item, index) => {
            if (item.upStandard == id) {
              item.show = state
            }
          })
        } else {
          this.markerList.forEach((item, index) => {
            if (item.currentStandard) {
              if (item.currentStandard.id == id) {
                item.show = state
              }
            }
          })
        }

      } else {
        this.onlineStateList[index].show = !this.onlineStateList[index].show
        let state = JSON.parse(JSON.stringify(this.onlineStateList[index].show))
        // 预警状态部分
        if (index == 2) {
          console.log('markerList', this.markerList)
          this.markerWarnState = !this.markerWarnState
          this.handleSite(this.markerList, this.selectType)
          // this.markerList.forEach((item, index) => {
          //   if (item.warnStatus == true) {
          //     item.show = state
          //   }
          // })
        } else {
          this.markerList.forEach((item, index) => {
            if (item.onlineStatus == id) {
              item.show = state
            }
          })
        }


      }
      // 监视者监控
      if (id == 'monitor') {
        let state = JSON.parse(JSON.stringify(this.standardList[selectedIndex].children[index].data.show))
        this.monitorVideoList.forEach((item, index) => {
          item.show = state
        })
      }
    },
    // 获取日报数据
    getDateList(st) {
      let params = {
        st
      }
      this.dateList = []
      this.dateFactorList = []
      queryWastDateList(params).then((res) => {
        if (res.success) {
           if (res.result.query.factors.length > 0) {
            res.result.query.factors.forEach(item=>{
              item['title'] = `${item.title}(${item.unitName})`
            })
            // console.log('factorArr', factorArr)
            this.dateFactorList = res.result.query.factors
            if(!(this.factorValue!=='' && this.dateFactorList.findIndex(item=>item.code===this.factorValue)!==-1)){
              // 默认累计污水量
              this.factorValue = this.dateFactorList.findIndex(item=>item.code==='05') !== -1 ? '05' : this.dateFactorList[0].code
            }
            
            console.log('res.result.query.factors', this.dateFactorList)
          }
          if (res.result.records.length > 0) {
            let qualifiedArr = []
            let disqualifiedArr = []
            res.result.records.forEach((item, index) => {
              
              if (item.attrs.upStandard) {
                qualifiedArr.push(item)
              } else {
                disqualifiedArr.push(item)
              }
            })
            this.dateList = [...qualifiedArr, ...disqualifiedArr]
          }
         
        } else {
          this.dateList = []
        }
      })
    },
    // 获取一张图数据
    getData(st) {
      // queryWastSiteStand({
      // 	st
      // }).then((res) => {
      // 	if (res.success) {
      // 		let obj = {}
      // 		let arr = []
      // 		for (let key in res.result.standardMap) {
      // 			obj.name = key
      // 			obj.value = res.result.standardMap[key]
      // 			arr.push(obj)
      // 			obj = {}
      // 		}
      // 		this.standardMap = arr
      // 		// this.$refs.ratio.initBarChart(arr)
      // 		if (res.result.totle > 0) {
      // 			this.$refs.ball.initBarChart((res.result.compliant / res.result.totle).toFixed(4))
      // 		} else {
      // 			this.$refs.ball.initBarChart((0).toFixed(4))
      // 		}
      // 	}
      // })
    },
    scroll() {
      setTimeout(() => {
        if (this.waterWarnList.length > 5) {
          this.waterWarnList.push(this.waterWarnList[0]) // 将数组的第一个元素添加到数组的
          this.waterWarnList.shift() //删除数组的第一个元素
        }
        if (this.dateList.length > 13) {
          this.dateList.push(this.dateList[0]) // 将数组的第一个元素添加到数组的
          this.dateList.shift() //删除数组的第一个元素
        }
        if (this.dateLists.length > 8) {
          this.dateLists.push(this.dateLists[0]) // 将数组的第一个元素添加到数组的
          this.dateLists.shift() //删除数组的第一个元素
        }
      }, 500)
    },

  },
}
</script>
<style scoped lang='scss'>
.amap-box {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}

.map-select {
  color: #fff;
  position: absolute;
  top: 160px;
  left: 510px;
  display: flex;
  font-size: 20px;
}

.map-select div {
  padding: 0 20px;
  border-radius: 10px;
  margin-left: 20px;
  border: 1px solid #0ff;
  background: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  user-select: none;
}

.selected {
  color: #0ff !important;
  // background: #0ff !important;
}

.bg-content {
  width: 100%;
  display: flex;
  justify-items: center;
  justify-content: space-between;
  padding: 0 15px;
}

/* 注释部分 单选按钮部分*/

/* .content-tab {
		position: absolute;
		top: 70px;
		left: 770px;
		height: 30px;
		border-radius: 10px;
		background: #fff;
		display: flex;
		align-items: center;
		z-index: 12;
	} */

.tabs-items {
  color: #0cc;
  width: 70px;
  height: 30px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 15px 0;
}

.item-recs {
  background: url('../../../../../assets/others/index/tab-img.png') no-repeat;
  color: #2c58a6;
  line-height: 30px;
  background-size: 100% 100%;
  padding: 0 10px;
  font-size: 15px;
  cursor: pointer;
  color: #0cc;
  padding: 10 20px;
  text-align: center;
}

.bold {
  background: url('../../../../../assets/others/index/tab-img-select.png') no-repeat;
  color: #2c58a6;
  background-size: 100% 100%;
  font-weight: bold;
}

/* end */
.tab-top {
  position: absolute;
  top: 2vw;
  left: 26vw;
  z-index: 12;
  display: flex;
}

.content-tabs {
  /* position: absolute;
		top: 70px;
		left: 655px; */
  display: flex;
  height: 30px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.tabs-bg {
  height: 20px;
  display: flex;
  align-items: center;
}

.tabs-item {
  // width: 130px;
  width: 80px;
  height: 12px;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2c58a6;
  border-right: 1px dashed #ccc;
  cursor: pointer;
  user-select: none;
  /* line-height: 30px;
  text-align: center;
  background: blue;
  transform: skewX(-45deg);
  display: flex;
  justify-content: center;
  color: #0ff;
  cursor: pointer; */
}

.tabs-item:last-child {
  border: none;
}

.tabs-item :hover {
  opacity: 0.7;
}

.item-rec {
  // background: url('../../../../../assets/others/index/tab-img-select.png') no-repeat;

  background-size: 100% 100%;
  height: 100%;
  line-height: 12px;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
}

.iconfont {
  font-size: 20px;
  margin-right: 5px;
}

.ant-radio-wrapper {
  color: #fff !important;
}

.ant-radio-group {
  position: absolute;
  top: 20px;
  left: calc(50% - 98px);
}

/deep/.amap-controls {
  display: none;
}

/deep/.amap-copyright {
  visibility: hidden !important;
}

/deep/.amap-info-content {
  background: #0a0b58 !important;
  border-radius: 10px !important;
}

/deep/.amap-info-close {
  right: 15px !important;
  top: 8px !important;
  font-size: 26px;
}

/deep/.amap-info-sharp {
  border-top: 8px solid #0a0b58;
}

.map-tag {
  min-width: 100px;
  height: 50px;
  background-color: #111f30;
  position: absolute;
  /* bottom: 16px; */
  top: 1000px;
  left: 480px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  user-select: none;
}

.map-tag-cir {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 10px;
  color: #999;
  text-align: center;
  line-height: 30px;
  margin-left: 10px;
  cursor: pointer;
}

.map-tag-rec {
  width: 30px;
  height: 30px;
  /* border-radius: 50%; */
  font-size: 10px;
  color: #fff;
  text-align: center;
  line-height: 30px;
  margin-left: 10px;
  cursor: pointer;
}

.window-container {
  position: fixed;
  top: 20%;
  left: 35%;
  background: #0b2554;
  z-index: 10;
  border-radius: 10px;
  padding: 0 10px;
  padding-bottom: 15px;

  .window-close {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 30px;
    cursor: pointer;
  }

  .window-title {
    font-size: 1rem;
    margin: 10px 0;
  }

  .window-content {
    font-size: 1rem;
    width: 28vw;
  }

  .marker-item {
    padding: 12px 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    line-height: 1.4;
    position: relative;
    overflow: hidden;
    color: rgba(255, 255, 255, 0.8);
    display: flex;
    // flex-direction: column;
    gap: 6px;
  }

  .marker-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    height: 100%;
    background-color: transparent;
    transition: all 0.3s ease;
  }

  .marker-item:hover {
    background-color: rgba(255, 255, 255, 0.08);
    padding-left: 20px;
    color: #ffffff;
  }

  .marker-item:hover::before {
    background-color: #00ffff;
  }

  .marker-item:last-child {
    border-bottom: none;
  }

  .marker-item:first-child {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }


  .marker-item-content {
    display: flex;
    flex-direction: column;

    .marker-item-name {
      font-size: 15px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.9);
      display: flex;
      align-items: center;

      // margin-left: 16px;
      .marker-item-icon {
        width: 22px;
        height: 20px;
        margin-right: 10px;
      }
    }

    .marker-item-lasttime {
      margin-top: 5px;
      margin-left: 30px;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.6);
      // margin-left: 16px;
    }
  }


  .no-data {
    padding: 8vh 0;
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
    font-size: 1.5rem;
  }
}

.site-infos,
.site-container {
  min-height: 270px;
  width: 570px;
  /* width: 770px; */
  /* padding-top: 25px; */

  .site-infos-content {
    width: 92%;
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 10px;
  }

  .site-header {
    color: #0ff;
    display: flex;
    margin-left: 5px;

    .site-header-container {
      display: flex;
      flex-direction: column;
      margin-top: 15px;
      margin-right: 10px;
      width: 187px;
      height: 363px;
      border-radius: 10px;
      border: 1px dashed #fff;

      img {
        width: 176px;
        height: 120px;
        border-radius: 10px;
        margin-left: 4px;
        margin-top: 5px;
      }

      .site-header-content {
        display: flex;
        justify-content: space-around;
        margin-left: 10px;
        flex-direction: column;
        width: 90%;
        margin-top: 10px;

        .site-header-name {
          display: flex;
          align-items: center;
          margin-top: 10px;

          .site-name {
            font-size: 15px;
          }

          .iconfont {
            font-size: 22px;
          }

          .site-area {
            font-size: 16px;
            color: #fff;
            /* overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap; */
          }
        }
      }
    }

    .site-header-info {
      width: 210px;
      height: 120px;
      border-radius: 10px;
      border: 1px solid #0ff;

      .site-content {
        height: 25%;
        width: 100%;
        border-bottom: 1px solid #0fff;
        text-align: center;
        font-size: 12px;
        line-height: 28px;
      }

      .site-content:last-child {
        border: none;
      }
    }
  }

  .site-info-tab {
    width: 775px;
    height: 100px;
    background: #4374e0;
    color: #fff;
    border-radius: 20px;
    margin-top: 15px;
    display: flex;

    .site-tab-left {
      width: 40%;
      height: 93%;
      margin-top: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #fff;
      border-right: 1px solid #fff;

      // color: #0ff;
      .icon-shishidaping {
        font-size: 36px;
      }

      .site-tab-name {
        font-size: 18px;
      }
    }

    .site-tab-right {
      width: 60%;
      height: 93%;
      margin-top: 4px;
      border-right: 1px solid #fff;

      .site-tab-title {
        width: 100%;
        height: 50%;
        line-height: 50px;
        text-align: center;
        border-bottom: 1px solid #fff;
        font-family: 'UnidreamLED';
        font-size: 23px;
        color: #0ff;
      }

      .site-tab-num {
        width: 95%;
        height: 50%;
        line-height: 50px;
        text-align: center;
        color: #0ff;
        font-size: 16px;
      }
    }

    .site-tab-right:last-child {
      border: none;
    }
  }
}

.realtime-bg {
  right: 35%;
  position: absolute;
  top: 40%;
  font-size: 22px;
  color: green;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 3px solid green;
  text-align: center;
  transform: rotate(-14deg);
  display: flex;
  flex-direction: column;
  line-height: 25px;
  align-items: center;
  justify-content: center;
}

.realtime-bg-red {
  right: 35%;
  position: absolute;
  top: 40%;
  font-size: 22px;
  color: red;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 3px solid red;
  text-align: center;
  line-height: 25px;
  transform: rotate(-14deg);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.content-tab {
  /* position: absolute;
		top: 70px;
		left: 480px; */
  display: flex;
  height: 30px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  align-items: center;
  z-index: 12;
}

.tabs-items {
  color: #0cc;
  width: 70px;
  height: 30px;
  /* width: 130px;
	  height: 40px; */
  background: rgba(0, 0, 0, 0.7);
  border-radius: 15px 0;
}

.air-container {
  position: absolute;
  left: 207px;
  top: 30px;
  width: 570px;
  height: 363px;
  margin-top: 20px;
  border: 1px solid #fff;
  border-radius: 10px;
}

.site-items {
  display: flex;
  height: 110px;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  width: 190px;
  overflow: hidden;
}

.site-items:first {
  margin-left: 0;
}

.site-details {
  display: flex;
  flex-direction: column;
  line-height: 37px;
  justify-content: space-between;
  height: 87px;
  margin-left: 20px;
}

/deep/.amap-marker-label {
  position: absolute;
  z-index: 2;
  background-color: white;
  white-space: nowrap;
  cursor: default;
  padding: 3px 8px;
  font-size: 12px;
  line-height: 14px;
  border-radius: 10px;
  border: none;
  color: #000;
}



</style>

<style>
  .factor-select .ant-select-selection{
    background: transparent !important;
    color: #fff !important;
    border: 1px solid #24649c !important;
  }
  .factor-select .ant-select-arrow{
    color: #fff !important;
  }
</style>
